export default {
  common: {
    campany: 'COMPANY',
    ourStory: 'ARTIST',
    audition: 'AUDITION',
    contact: 'CONTACT',
    information: 'INFORMATION',
    blix: 'BLIX CREATES THE FUTURE OF ENTERTAINMENT —',
    makingTomorrow: 'MAKING TOMORROW’S',
    inspirations: 'INSPIRATIONS POSSIBLE TODAY',
    home: 'HOME',
    copyrightBlix: '© Copyright Blix Entertainment. ALL RIGHT RESERVED',
    standsFor: '"BLIX" STANDS FOR',
    brilltance: 'BRILLIANCE.',
    speed: 'SPEED.',
    stability: 'STABILITY.',
    vitality: 'VITALITY.',
    tip: 'BLIX is a global entertainment company that builds an integrated ecosystem across artist discovery, development, music production, technological innovation, and creative storytelling.  ',
    tip1: 'We believe that creativity is a lasting force — one that keeps burning, keeps driving, and continues leaving a profound mark over time.',
    tip2: 'BLIX operate a fully structured entertainment system, connecting stories, artists, and fans around the world.',
    tip3: 'From talent scouting and professional training to music production, visual storytelling, branding, and global expansion, we build a sustainable and enduring influence in the entertainment industry.',
    visionary: 'VISIONARY ENTERTAINMENT',
    tip4: 'In the rapidly evolving global and creative economy, BLIX has built a sustainable and flexible entertainment system.Every step is meticulously designed based on professional standards, nurturing, and a future-oriented vision, paving the way for a new direction in entertainment.',
    atTheHeart:'At the heart of BLIX lies endless possibilities and fresh vision.', 
    wePrepare:'We prepare a cultural stage that goes beyond trends and leads generations.', 
    togetherWeGrow:'Together, we grow into BLIX Entertainment, setting new benchmarks on the global stage.',
    ourCompleteSystem: 'OUR COMPLETE SYSTEM',
    casting: 'CASTING',
    trainingDevelopment: 'TRAINING & DEVELOPMENT',
    musicProduction: 'MUSIC PRODUCTION',
    brandingStoryIP: 'BRANDING & STORY IP',
    marketingFanSystem: 'MARKETING & FAN SYSTEM',
    globalBusiness: 'GLOBAL BUSINESS',
    crossIndustryCollaboration: 'CROSS-INDUSTRY COLLABORATION',
    weContinue: 'We continue to grow with like-minded cultural innovators, including.',
    artists: 'ARTISTS',
    technologyDevelopers: 'TECHNOLOGTY',
    creativeStrategists: 'CREATIVE STRATEGISTS',
    weBelieve: 'BLIX grows together with cultural innovators, nurturing artists and collaborating across diverse fields such as.',
    atBlix:'At BLIX, we believe that an artist’s dream is our shared future.',
    thatFunture:'That future is already taking shape here, becoming reality through music and storytelling.',
    creativeSpace: 'CREATIVE SPACE',
    tip5: 'YOU WILL BE PART OF BLIX’S GLOBAL ARTIST PROJECT, EMBARKING ON AN EXCLUSIVE JOURNEY OF GROWTH AND OFFICIALLY STEPPING ONTO THE PATH TOWARD THE WORLD’S SPOTLIGHT',
    spotlight: 'Join BLIX — Step Into Your Spotlight',
    blixShien: 'BLIX PROVIDES THE IDEAL ENVIRONMENTFOR THE NEXT GENERATION OF ARTISTS TOGROW AND SHINE',
    tip20: 'WE ARE CREATING A NEW ERA OF PERFORMERS DRIVEN BY MUSIC, VISUALS, AND POWERFUL STORYTELLING—WHERE EVERY DREAMER CAN TAKE CENTER STAGE AND BECOME THE STAR OF THEIR OWN STORY',
    forYou: 'IF YOU BELIEVE YOU BELONG ON THIS STAGE, BLIX IS WAITING FOR YOU',
    apllyNow: 'APLLY NOW',
    pleaseleave:'Please leave your inquiry, and our team will review and respond accordingly.',
    name:'NAME',
    email:'EMAIL',
    contactNumber:'CONTACT NUMBER',
    inquiryDetails:'INQUIRY DETAILS',
    contact2:"CONTACT",
    agreePolicy:'I agree to the Privacy Policy.',
    submitInquiry:'Submit inquiry',
    seoulHq:'SEOUL HQ ',
    add:'6 SEONGMISAN-RO 6-GIL, ',
    add1:'MAPO-GU, SEOUL, ',
    add2:'REPUBLIC OF KOREA [03996]',
    add3:'서울특별시 마포구 성미산로6길 6 (망원동, BLIX 빌딩) ',
    hongKong:'HONG KONG OFFFICE',
    midtown:'1811, ONE MIDTOWN,',
    hoiShing:'11 HOI SHING ROAD, TSUEN WAN,',
    hongKong1:' HONG KONG',
    onlineAuditin:'ONLINE AUDITION GUIDE',
    auditionCategories:'Audition Categories',
    dataTyle:'VOCAL / RAP / DANCE / ACTING',
    applicationPeriod:'Application Period',
    openYearRound:'Open year-round', 
    eligibility:'Eligibility', 
    noRestrictions:'No restrictions – anyone can apply', 
    howToApply:'How to Apply',
    step1:'STEP 1',
    auditionForm:'Click “Apply” and complete the audition form.',
    step2:'STEP 2',
    uploadRequired:'Upload the required files:',
    photos:'Photos',
    clearPhoto:'• One clear upper-body photo',
    frontView:'• One full-body photo (front view)',
    videoSubmission:'Video Submission',
    videoAudio:'• Vocal/Rap: At least 1 minute of singing or rapping (video or audio)',
    freestyledancing:'• Dance: At least 1 minute of freestyledancing',
    actingPerformance:'• Acting: At least 1 minute of monologue or acting performance',
    step3:'STEP 3',
    submityour:'Submit your application to complete the process.',
    auditionProcess:'Audition Process',
    stRound:'1st Round: Document Screening',
    videoSubmissionReview:'We review your application form, photos, and video submission.',
    ndRound:'2nd Round: On-Camera Evaluation',
    recordedVideoTest:'Selected applicants will participate in a recorded video test.',
    rdRound:'3rd Round: Final Audition & Result Notification',
    afterThisRound:'Finalists are invited for a live audition. Final decisions are made after this round.',
    auditionResults:'AUDITION RESULTS',
    tip6:'Successful applicants will be contacted by email or phone (as provided in your application) within 2 weeks of your audition date.',
    auditionResultsNotification:'AUDITION RESULTS NOTIFICATION',
    tip7:'Only selected applicants will be contacted via the email address or phone number provided in the application form. Results will be shared within 2 weeks of the audition date.',
    importantNotes:'IMPORTANT NOTES',
    beReturned:'# Submitted materials will not be returned.',
    anyPhotosThat:'# Any photos that have been heavily edited or filtered (e.g., using Photoshop) may  be disqualified during the document screening process.',
    videosAudio:'# Low-quality videos or audio (e.g., blurry, out of focus, or unclear sound) may  negatively affect your evaluation.',
    questionsFurther:' # For questions or further assistance, please email: ',
    apply:'APPLY',
    pleaseEnter1:'Please enter your information acturately to apply for the audition',
    emailAddress:'EMAIL ADDRESS',
    VerifyEmail:'Verify Email',
    lastName:'LAST NAME.',
    firstName:'FIRST NAME',
    dateOfBirth:'DATE OF BIRTH',
    select:'PLEASE SELECT',
    enter:'PLEASE ENTER',
    profilePicture:'PROFILE PICTURE',
    upload:'Upload',
    pleaseUpload:'PLEASE UPLOAD',
    performanceCategory:'PERFORMANCE CATEGORY',
    gender:'GENDER',
    height:'HEIGHT',
    height1:'HEIGHT(CM)',
    weight:'WEIGHT',
    weight1:'WEIGHT(KG)',
    phone:'PHONE',
    phone1:'PLEASE FILL OUT THE FORM WITHOUT USING',
    schoolJob:'SCHOOL/J0B',
    schoolJob1:'EPLEASE FILL OUT THE FORM WITHOUT USING',
    emergencyContact:'EMERGENCY CONTACT',
    emergencyContact1:'PLEASE FILL OUT THE FORM WITHOUT USING',
    placeOfresidence:'PLACE OF RESIDENCE',
    socialMediaId:'SOCIAL MEDIA ID',
    specialtv:'SPECIALTY',
    activtiesAwarsds:'ACTIVITIES & AWARDS',
    activtiesExperience:'AUDITION EXPERIENCE',
    specialNote:'SPECIAL NOTE',
    attachFile:'ATTACH FILE',
    profileAttachFile:'PROFILE ATTACH FILE',
    consentInformation:'I CONSENT TO THE COLLECTION AND USE OF MY PERSONAL INFORMATION.',
    submitApplicatior:'Submit Application',
    tit1:'[COLLECTION AND USE OF PERSONALINFORMATION]',
    tip8:'THE APPLICANT AGREES AND CONSENTS TOBLIX ENTERTAINMENT(HEREINAFTERREFERRED TO AS "THE COMPANY")COLLECTING AND USING THE FOLLOWINGPERSONALINFORMATION FORTHEPURPOSES OUTLINED BELOW:',
    tip9:".PURPOSE OF COLLECTION AND USE:TO VERIFY THE APPLICANT'S IDENTITY,MANAGE AUDITION APPLICATIONS, EVALUATETALENT SUITABILITY, AND CONDUCT ALLNECESSARYPROCESSES RELATED TOTRAINEE SELFCTION",
    tip10:".PERSONALINFORMATIONCOLLECTEDCATEGORY, FULL NAME, DATE OF BIRTH,NATIONALITY,RESIDENTIAL ADDRESS, EMAIL,CONTACT NUMBER, AGE, HEIGHT, WEIGHT.AWARDS AND RECOGNITIONS,SCHOOL ANDGRADE,AND SOCIAL MEDIA ACCOUNTS,IMAGES AND VIDEOS.",
    tip11:".RETENTION AND USE PERIOD:FROM THE DATE THIS CONSENT ISSUBMITTED, THE COMPANY MAY RETAIN ANDUSE THE INFORMATION FOR A PERIOD OFTWO (2) YEARS, OR UNTIL CONSENT ISWITHDRAWN BY THE APPLICANT IN WRITING",
    tip12:"THE APPLICANT SHALL PROMPTLY INFORMTHE COMPANY OF ANY UPDATES ORCHANGES TO THE INFORMATION PROVIDEDTHE COMPANY IS ENTITLED TO COLLECT ANDUTILIZE THE UPDATED INFORMATION UNDERTHE SAME TERMS.",
    tip13:"REFUSAL TO CONSENT MAY RESULT IN THEINABILITY TO PROCESS THE APPLICATION ORTO PROCEED WITH AUDITION-RELATEDMATTERS.THE APPLICANT SHALL BE SOLELYRESPONSIBLE FOR ANY DISADVANTAGE ORCONSEQUENCES RESULTING FROM SUCHREFUSAL.",
    tit2:'[DELEGATION OF PERSONAL INFORMATIONPROCESSING TO A THIRD PARTY]',
    tip14:'PURPOSE OF DELEGATION: TO HOST ANDMANAGE THE BLIX ENTERTAINMENTAUDITION PLATFORM AND ITS RELATED DATASECURELY VIA SERVERS',
    tip15:"THE APPLICANT HAS THE RIGHT TO REFUSECONSENT TO THIRD-PARTY DATAPROCESSING.HOWEVER,SUCH REFUSAL MAYRESTRICT THE APPLICANT'S ABILITY TOPARTICIPATE IN THE AUDITION PROCESSTHROUGH THE OFFICIAL PLATFORM.",
    tit3:'[CONSENT TO CONTENT RECORDING ANDUSE]',
    tip16:'THE APPLICANT CONSENTS TO THE COMPANYRECORDING, FILMING,PHOTOGRAPHING,OROTHERWISE CAPTURING THEIR LIKENESSVOICE, AND PERFORMANCE DURING THEAUDITION PROCESS.ALL RECORDEDMATERIALS (HEREINAFTER REFERRED TO AS"CONTENT") MAY BE STORED AND USED BYTHE COMPANY FOR PURPOSES OFEVALUATION,INTERNAL USE,RECORD-KEEPING.TALENT DEVELOPMENT, AND-IF ATRAINEE OR EXCLUSIVE AGREEMENT ISOFFERED-FACILITATING AND EXECUTINGSUCH AGREEMENTS',
    tit4:'[INTELLECTUAL PROPERTY RIGHTS OF THE CONTENT]',
    tip17:'ALL COPYRIGHTS (INCLUDING DERIVATIVE RIGHTS), IMAGE RIGHTS, AND ANY OTHER INTELLECTUAL PROPERTY RIGHTS RELATEDTO THE CONTENT SHALL BE EXCLUSIVELY AND SLOBALLY OWNED BY BLIX ENTERTAINMENT. THE APPLICANT WAIVES ANY RIGHT TO CLAIM OWNERSHIP, ROYALTIES, OR COMPENSATIONIN RELATION TO THE CONTENT, UNLESSOTHERWISE AGREED IN WRITING.',
    pleaseSelect:'Please enter',
    pleaseCheck:'Please check the agreement',
    submissionSuccessful :'Submission successful',
    male:'Male',
    female:'Female',
    submissionFailed:'Submission failed',
    pleaseEmailAddress:'Please enter your email address',
    sentSuccessfully:'Sent successfully',
    attachFile:'Attach a file',
    imageFileSuch:'Image file such as .jpg .png/MAX 50MB',
    fileSize:'File size must be less than 50MB!',
    fileSize1:'File size must be less than 100MB!',
    uploadFailed:'Upload failed',
    attach:'Attach',
    emailVerification:'Email verification failed to send',
    privacyPolicy:'Privacy Policy',
    tip21:'BLIX Entertainment (“we,” “our,” or “us”) respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and safeguard your information when you use our website and services.',
    tip22:'1. Information We Collect',
    tip23:'•	Name, email address, phone number, and other details you provide when submitting an inquiry.',
    tip24:'•	Technical information such as IP address, browser type, and access logs.',
    tip25:'2. How We Use Your Information',
    tip26:'•	To respond to your inquiries and provide customer support.',
    tip27:'•	To improve our website and services.',
    tip28:'•	To comply with legal obligations.',
    tip29:'3. Information Sharing',
    tip30:'•	We do not sell or rent your personal data.',
    tip31:'•	We may share information with trusted service providers only to operate our services.',
    tip32:'•	We may disclose information when required by law.',
    tip33:'4. Data Retention',
    tip34:'•	We keep your information only as long as necessary to fulfill the purposes outlined above.',
    tip35:'5. Data Security',
    tip36:'•	We implement reasonable security measures to protect your information, but cannot guarantee absolute security.',
    emailUnverified:'Email unverified',
    tip37:'BLIX HEADQUARTERS IS IN A MULTI-LEVELCREATIVE COMPLEX,WHERE EACH FLOORIS DEDICATED TO A SPECIALIZED FUNCTION-TRAINING, MUSICPRODUCTION, VISUAL DEVELOPMENT AND CONCEPT CREATION.',
    tip38:'WHERE CREATIVITY AND INNOVATION TECHNOLOGY MERGE TO SHAPE WHAT ENTERTAINMENT BECOMES NEXT.',
    year:'Year',
    award:'Award',
    categoryWork:'Category / Work',
    brandOfTheYearAwards:'Brand of the Year Awards',
    femaleVocalist:'Female Vocalist',
    rdKYStarAwards:'3rd KY Star Awards',
    millionSongLogs:'10 Million Song Logs',
    gaonChartMusicAwards:'9th Gaon Chart Music Awards',
    discoveryoftheYearBallad:'Discovery of the Year – Ballad',
    melonMusicAwards:'Melon Music Awards',
    topArtists:'Top 10 Artists',
    songDayWasBeautiful:'Song of the Year (Daesang) – The Day Was Beautiful',
    bestBallad:'Best Ballad',
    goldenDiscAwards:'34th Golden Disc Awards',
    digitalBonsang:'Digital Bonsang',
    seoulMusicAwards:'29th Seoul Music Awards',
    bonsangMainPrize:'Bonsang (Main Prize)',
    popularityAward:'Popularity Award',
    KWaveAwards:'K-Wave Awards',
    bestAwardRewind:'Best R&B Award (Rewind)',
    koreaCulturalEntertainmentAwards:'Korea Cultural & Entertainment Awards',
    kStarAward:'K-POP Star Award',
    artistTheYear:'Artist of the Year',
    topArtistAward:'Top 10 Artist Award',
    bestFemaleSoloArtist:'Best Female Solo Artist',
    tip39:"THE BLIX BUILDING IS A CREATIVE BASE THAT UNITES TRAINING, MUSIC, AND VISUAL PRODUCTION IN ONE INTEGRATED ECOSYSTEM",
    tip40:"— A SPACE WHERE IDEAS EXPAND FREELY, AND CREATIVITY NEVER STOPS EVOLVING.",
  },
};